export const GOOGLE_PHOTOS_API = 'https://photoslibrary.googleapis.com/v1';
export const MEDIA_ITEMS_API = `${GOOGLE_PHOTOS_API}/mediaItems`;
export const MEDIA_ITEMS_SEARCH_API = `${MEDIA_ITEMS_API}:search`;
